//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
    // Please make all SWYM-related API calls inside this function.
    // You can use the swat argument within this scope.
    if (swat) {
        console.log("Swym scripts tags are installed on your store");
        let rating_date = document.querySelector('.jdgm-rev__timestamp')
        document.querySelectorAll('.jdgm-rev').forEach((rev) => {
            let time = rev.querySelector('.jdgm-rev__timestamp');
            rev.querySelector('.jdgm-row-profile').appendChild(time);
        })
    }
}
if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);